<template>
    <div>
        <router-view :key="$route.fullPath" />
        <loading />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from './components/Loading.vue';
import MobileHelper from './helper/MobileHelper';
import { exitDialog } from './helper/DialogHelper';
//import ScreenHelper from './helper/ScreenHelper';
import { CORDOVA_SRC, LANGUAGE } from './const';
export default {
    name: 'App',
    components: { loading },
    data: () => {
        return {
            bodyCls: ''
        };
    },
    computed: {
        ...mapState({
            network: state => state.device.network,
            screen: state => state.device.screen
        })
    },
    watch: {
        $route: 'fetchData'
    },
    created() {
        this.uiInit();
    },
    mounted() {
        /* 추가되어야 할 API */
        //PC에서의 개발편의를 위해서 웹뷰인 경우만 corova.js를 load 하도록 처리함
        this.$i18n.locale = localStorage.getItem(LANGUAGE) || 'ko';
        //document.addEventListener('backbutton', this.backbtn, false);
        console.log(MobileHelper.isWebView());
        if (MobileHelper.isWebView()) {
            const platform = MobileHelper.getPlatform();
            console.log();
            if (platform) {
                var script = document.createElement('script');
                script.onload = () => {
                    document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
                };
                script.onerror = () => {
                    console.error('script load error');
                };
                console.log(process.env);
                script.src = process.env.CORDOVA_DOMAIN;
                document.head.appendChild(script);
            }
        }
    },
    destroyed() {},
    methods: {
        ...mapActions(['setNetworkState', 'setScreenOrientation', 'showLoading', 'hideLoading']),
        backbtn() {
            exitDialog();
        },
        doLastAccess() {
            MobileHelper.doLastAccess();
        },
        onDeviceReady() {
            //const platform = MobileHelper.getPlatform();
            //if (platform !== 'ios') this.syncCodePush();
        },
        orientationChange() {
            this.setScreenOrientation(window.screen.orientation.type);
        },
        networkOnline() {
            this.setNetworkState(navigator.connection.type);
        },
        networkOffline() {
            this.setNetworkState(navigator.connection.type);
        },
        fetchData() {
            this.showLoading();
            this.uiInit();
        },
        uiInit() {
            if (this.$route.meta.bodyClass) {
                document.body.classList = this.$route.meta.bodyClass;
            }
        }
    }
};
</script>
